/* eslint-disable ember/no-computed-properties-in-native-classes */
import { computed } from '@ember/object';

import * as ReverseImplementation from './reverse-implementation';
import BigHugeCircuit from './big-huge-circuit';
import BaseBigHugeCircuitGroup from '../../implementation-common/base-big-huge-circuit-group';

export default class DeliyannisBandPassBigHugeCircuitGroup extends BaseBigHugeCircuitGroup {
  circuit;
  reverseImplementation = ReverseImplementation;
  @computed('circuit', 'nominalValues', 'reverseImplementation', 'gbwArray') get circuits() {
    var circuit = this.circuit;
    var nominalGbw = circuit.opAmp.gbw;
    var nominalValues = this.nominalValues;
    var reverseImplementation = this.reverseImplementation;
    var c1ToleranceArray = circuit.c1.toleranceArray;
    var c2ToleranceArray = circuit.c2.toleranceArray;
    var r1ToleranceArray = circuit.r1.toleranceArray;
    var r2ToleranceArray = circuit.r2.toleranceArray;
    var r3ToleranceArray = circuit.r3.toleranceArray;
    var r4ToleranceArray = circuit.r4.toleranceArray;
    var r5ToleranceArray = circuit.r5.toleranceArray;
    var linkedArrayOne = circuit.r1.value ? r1ToleranceArray : r2ToleranceArray;
    var linkedArrayTwo = circuit.c1.value ? c1ToleranceArray : c2ToleranceArray;
    var inverseArray = circuit.r3.value ? r3ToleranceArray : r4ToleranceArray;

    var r4Start = r3ToleranceArray.length - 1;
    var gbwArray = this.gbwArray;
    var bigHugeCircuitArray = [];
    gbwArray.forEach((gbwValue) => {
      linkedArrayOne.forEach((linkedOne, indexLinkedArrayOne) => {
        var r1Value = r1ToleranceArray[indexLinkedArrayOne];
        var r2Value = r2ToleranceArray[indexLinkedArrayOne];
        inverseArray.forEach((inverseItem, indexInverseArray) => {
          var r3Value = r3ToleranceArray[indexInverseArray];
          var r4Value = r4ToleranceArray[r4Start - indexInverseArray];
          r5ToleranceArray.forEach((r5Value) => {
            linkedArrayTwo.forEach((linkedTwo, indexLinkedArrayTwo) => {
              var c1Value = c1ToleranceArray[indexLinkedArrayTwo];
              var c2Value = c2ToleranceArray[indexLinkedArrayTwo];
              let item = BigHugeCircuit.create({
                c1: c1Value,
                c2: c2Value,
                r1: r1Value,
                r2: r2Value,
                r3: r3Value,
                r4: r4Value,
                r5: r5Value,
                opAmpGbw: gbwValue,
                nominalValues: nominalValues,
                nominalGbw: nominalGbw,
                reverseImplementation: reverseImplementation,
              });
              bigHugeCircuitArray.push(item);
            });
          });
        });
      });
    });

    var result = this.setNormalizers(bigHugeCircuitArray);
    return result;
  }
}
